module.exports = __webpack_public_path__ + "static/media/imagem1.84abab61.jpeg";